import { Award, CircleUserRound, LogOut } from "lucide-react";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  useSidebar,
} from "../ui/sidebar";
import { useMsal } from "@azure/msal-react";
import { useAuth } from "@/context/AuthContext";

export function AppUser() {
  const { open } = useSidebar();
  const { instance } = useMsal();
  const { account, currentUser } = useAuth();

  // Helper function to format role name for display
  const formatRoleName = (roleSlug: string): string => {
    return roleSlug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (!currentUser || !account)
    return (
      <>
        <SidebarMenuItem>
          <SidebarMenuSkeleton />
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuSkeleton />
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuSkeleton />
        </SidebarMenuItem>
      </>
    );

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        {open ? (
          <SidebarMenuButton disabled className="disabled:opacity-100">
            <CircleUserRound />{" "}
            <span>
              <b>{currentUser.name}</b>
            </span>
          </SidebarMenuButton>
        ) : null}
        {open ? (
          <SidebarMenuButton disabled className="disabled:opacity-100">
            <Award />{" "}
            <span>
              Role: <b>{formatRoleName(currentUser.role)}</b>
            </span>
          </SidebarMenuButton>
        ) : null}
        <SidebarMenuButton
          className="mt-2"
          onClick={() =>
            instance.logoutRedirect({
              account,
              postLogoutRedirectUri: "/",
            })
          }
          tooltip="Sign Out"
        >
          <LogOut /> <span>Sign Out</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
